<template>
  <div>
    <h4>Datos pagador</h4>
    <b-form @submit="pagoPSE">
      <b-form-group
        id="input-group-tipoid"
        label="Tipo documento:"
        label-for="tipoid"
      >
        <b-form-select
          id="tipoid"
          :options="tipoDocs"
          v-model="tipoDoc"
          required
        ></b-form-select>
      </b-form-group>

      <b-form-group
        id="input-group-ide"
        label="Numero del documento:"
        label-for="ide"
      >
        <b-form-input
          id="ide"
          v-model="ident"
          type="text"
          :pattern="tipoDocs[tipoDoc - 1].pattern"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-nombre"
        label="Nombre completo:"
        label-for="nombre"
      >
        <b-form-input 
          id="nombre"
          type="text"
          v-model="nombre" 
          pattern="^[a-zA-Z]+(\s*[a-zA-Z]*)*[a-zA-Z]+" 
          required>
        </b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-email"
        label="Correo electronico:"
        label-for="email"
      >
        <b-form-input
          id="emailu"
          v-model="email"
          type="text"
          pattern="^[0-9a-zA-Z._\-]+@[a-zA-Z._\-]+\.[a-zA-Z]{2,3}"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-ide"
        label="Numero Celular:"
        label-for="tel"
      >
        <b-form-input
          id="telu"
          v-model="tel"
          type="text"
          pattern="^[1-9][0-9]{7,10}"
          required
        ></b-form-input>

        <div class="btn-pdf-trata" v-if="false">
            <router-link to="/preguntasfrecuentesptp" target="_blank">
              Preguntas Frecuentes Place to Pay
            </router-link>
        </div>

        <div class="btn-pdf-trata">
          <a href="https://registro.pse.com.co/PSEUserRegister/FAQ.html" target="_blank">Preguntas Frecuentes PSE</a>
        </div>

        <div class="btn-pdf-trata">
          <b-form-checkbox
            v-model="status"        
          >
            Acepta los terminos y condiciones
          </b-form-checkbox>
          <a href="#" @click="openPdf()"> Ver mas </a>
        </div>      
      </b-form-group>

      <b-button type="submit" class="btn-procesar-pse" variant="primary">
        Procesar Pago PSE
      </b-button>
      <b-button variant="danger" @click="cancelPagoPSE()"> Cancelar </b-button>
      <div style="margin-top: 1rem;" v-if="false">
        <img src="@/assets/logoptp.svg"></img>
      </div>
    </b-form>

    <b-modal scrollable v-model="pdfShowTrata" size="xl" title="Política de tratamiento de datos">
      <template v-slot:modal-header="{ close }">
        <h5> Política de tratamiento de datos </h5>
          <a download="Política de tratamiento de datos" href="/pse/tratamiento_svc.pdf">
          <b-icon icon="box-arrow-down"></b-icon>
          Descargar
        </a>
      </template>

      <pdf src="/pse/tratamiento_svc.pdf"></pdf>

      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="danger" @click="closePdf()">
          Salir
        </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  name: "Pagador",
  components: {
    pdf
  },
  data: function () {
    return {
      tipoDoc: 1,
      ident: null,
      nombre: null,
      email: null,
      tel: null,
      tipoDocs: [
        { text: "Cédula de Ciudadanía", value: 1, pattern: "^[1-9][0-9]{3,9}" },
        { text: "Nit", value: 2, pattern: "^[1-9]{6,9}" },
        { text: "Cédula de Extranjería", value: 3, pattern: "^([a-zA-Z]{1,5})?[1-9][0-9]{3,7}" },
      ],
      pdfShowTrata : false,
      status: false
    };
  },
  methods: {
    pagoPSE(event) {
      event.preventDefault();
      if(!this.status) {
        this.$bvToast.toast('Es obligatorio aceptar los terminos y condiciones', {
          title: 'Advertencia',
          autoHideDelay: 5000
        });

        return;
      }
      this.$emit("to-pse-event", [
        this.tipoDoc,
        this.ident,
        this.nombre,
        this.email,
        this.tel,
      ]);
    },
    cancelPagoPSE() {
      this.$emit("cancel-pse-event", null);
    },
    openPdf(){
      this.pdfShowTrata = true;
    },
    closePdf(){
      this.pdfShowTrata = false;
    }
  },
};
</script>

<style>
.btn-procesar-pse {
  margin-right: 1rem;
}

.btn-pdf-trata{
  margin-top: 1rem;
}
</style>
